import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPMProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPMProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pt- pl0">Npm:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          npm install --save {component.name}@{version.version}
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM;
